export default __webpack_public_path__ + "static/media/cny-wallet.72093dc1.webp";